import React from 'react';
import {LinkOnComponent} from 'app/components/links/link';
import {Typography} from '@fupa/fupa-uikit';
import {styled} from '@mui/material/styles';

const FirstMatch = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: -1.25rem;
`;

interface MatchHeaderFirstMatchProps {
  match: any;
}

export default function MatchHeaderFirstMatch({match}: MatchHeaderFirstMatchProps) {
  if (!match) {
    return null;
  }

  const hasResult = typeof match.awayGoal === 'number' && typeof match.homeGoal === 'number';

  const firstMatchResult = hasResult ? `${match.awayGoal}:${match.homeGoal}` : <span>&ndash;:&ndash;</span>;

  return (
    <FirstMatch>
      <LinkOnComponent to={`/match/${match.slug}`}>
        <Typography variant='caption1'>Hinspiel: {firstMatchResult}</Typography>
      </LinkOnComponent>
    </FirstMatch>
  );
}
